import { Component } from '@angular/core';

@Component({
    selector: 'wci-our-solution',
    imports: [],
    templateUrl: './our-solution.component.html',
    styles: ``,
})
export class OurSolutionComponent {}
